export const menuItems = [
  {
    title: "Map",
    url: "/",
  },
];
